import { LocalStorage } from "quasar";
import Deepstream from "../libs/deepstream/deepstream";
import Meeting from "../libs/deepstream/meeting";

const getDefaultState = () => {
  return {
    uid: null,
    cid: null,
    standby: true,
    currentInteraction: null,
    currentInteractionState: null,
    disableUserInteraction: false,
    showSecondaryText: false
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    uid(state, uid) {
      state.uid = uid;
    },
    cid(state, cid) {
      state.cid = cid;
    },
    standby(state, standby) {
      state.standby = standby;
    },
    currentInteraction(state, currentInteraction) {
      state.currentInteraction = currentInteraction;
    },
    currentInteractionState(state, currentInteractionState) {
      state.currentInteractionState = currentInteractionState;
    },
    disableUserInteraction(state, disableUserInteraction) {
      state.disableUserInteraction = disableUserInteraction;
    },
    showSecondaryText(state, showSecondaryText) {
      state.showSecondaryText = showSecondaryText;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    },
  },

  getters: {},

  actions: {
    async login({ commit, state, rootState }) {
      let uid = LocalStorage.getItem("uid");
      if (!uid) {
        uid = `${
          rootState.app.config.cid
        }-consumer-${Deepstream.getInstance().client.getUid()}`;
        LocalStorage.set("uid", uid);
      }
      const authInfo = await Deepstream.getInstance().login(uid, null);
      commit("cid", authInfo.cid);
      commit("uid", authInfo.uid);
    },
    async join({ commit }, recordName) {
      commit("reset");
      await Meeting.getInstance().join(recordName);
      await Meeting.getInstance().sendCustomerErrors();
    },
  },
};
